/* eslint-disable */
//ua 检测
function detect(ua){
    // app检测
    this.app = (function(){
        var ua = navigator.userAgent,
            result,
            weixin = false,
            mqq = false,
			QQLiveBrowser = false,
            kuaibao = false,
            qqnews = false,
            qb = false, 
            version = '';
        
        // 微信
        if(result = ua.match(/MicroMessenger\/([\d\.]*)/i)) {
          weixin = true;
          version = result[1];
        }
        
        // 手Q 
        else if(result = ua.match(/ QQ[\s\/]([\d\.]*)/i)) {
          mqq = true;
          version = result[1];
        }
		
		//腾讯视频webview 
		else if(result = ua.match(/QQLiveBrowser\/([\d\.]*)/i)) {
          QQLiveBrowser = true;
          version = result[1];
        }

        //天天快报webview 
        else if(result = ua.match(/qnreading\/([\d\.]*)/i)) {
          kuaibao = true;
          version = result[1];
        }

        //腾讯新闻webview 
        else if(result = ua.match(/qqnews\/([\d\.]*)/i)) {
          qqnews = true;
          version = result[1];
        }
        
        // qq浏览器 加一个URL判断 为了cover住qb浏览器福利中心注入user agent不正确的问题
		else if((result = ua.match(/MQQBrowser/i)) || window.location.pathname.includes('newtickets')) {
            qb = true;
            let result1 = ua.match(/MQQBrowser\/([\d\.]*)/i) || [];
            version = result1[1];
        }
        
        return {
            weixin:weixin,
            mqq:mqq,
			QQLiveBrowser:QQLiveBrowser,
            kuaibao:kuaibao,
            qqnews:qqnews,
            version:version,
            qb
        }
    })();

    //系统检测 
    this.os = (function(){
        var ua = navigator.userAgent,
            result,
            android = false,
            ios = false,
            iphone,
            ipad,
            ipod,
            version = '';
       
        
        // android
        if(result = ua.match(/(Android);?[\s\/]+([\d.]+)?/)) {
            android = true;
            version = result[2];
            //version = parseFloat(result[2]);
        }else {
            //ios
            iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/);
            ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            if(iphone){
                version = iphone[2];
				iphone = true;
                ios = true;
            }else if(ipad){
                version = ipad[2];
				ipad = true;
                ios = true;
            }else if(ipod){
                version = ipod[2];
				ipod = true;
                ios = true;
            }
        }
        
        return {
            android : android,
            ios : ios,
            iphone : iphone,
            ipad : ipad,
            ipod : ipod,
            version : version
        }
    })();

    //检测是否是移动设备
    this.isMobile = (function(){
         var agentTags = ['MQQBrowser','iphone','itouch','android','nokia','UC','TencentTraveler'],
            ua = navigator.userAgent.toLowerCase();
         for(var i = 0 ,len = agentTags.length; i < len; i++) {
            var reg = new RegExp(agentTags[i].toLowerCase());
            if(reg.test(ua)) {
                return true;
            }
         }
         return false;
    })();
  }

  const detector = {}
  
  detect.call(detector, navigator.userAgent)

  export default detector
